import type { ReadonlyUser } from './auth.service';

interface TEMPORARY_AuthServiceThatOriginatesFromReactOnly {
	loadIdentity(): Promise<{ ok: ReadonlyUser | null; err: unknown }>;
}

export const authServiceThatOriginatesFromReactOnly = {
	instance: null,
} as unknown as {
	instance: TEMPORARY_AuthServiceThatOriginatesFromReactOnly;
};
